import { render, staticRenderFns } from "./SwLiveVideo.vue?vue&type=template&id=569f0f04&"
import script from "./SwLiveVideo.vue?vue&type=script&lang=js&"
export * from "./SwLiveVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports